export default __webpack_public_path__ + "static/media/docusign.ff4adc14.svg";